import React from "react";
import PropTypes from "prop-types";

const Horizontal = ({ ticks = [], y, svg }: any) => {
  return (
    <g>
      {ticks.map((tick: any) => (
        <line
          key={tick}
          x1={"0%"}
          x2={"100%"}
          y1={y(tick)}
          y2={y(tick)}
          strokeWidth={1}
          stroke={"rgba(0,0,0,0.2)"}
          {...svg}
        />
      ))}
    </g>
  );
};

const Vertical = ({ ticks = [], x, svg }: any) => {
  return (
    <g>
      {ticks.map((tick: any, index: number) => (
        <line
          key={index}
          y1={"0%"}
          y2={"100%"}
          x1={x(tick)}
          x2={x(tick)}
          strokeWidth={1}
          stroke={"rgba(0,0,0,0.2)"}
          {...svg}
        />
      ))}
    </g>
  );
};

const Both = (props: any) => {
  return (
    <g>
      <Horizontal {...props} />
      <Vertical {...props} />
    </g>
  );
};

Vertical.propTypes = {
  x: PropTypes.func,
  dataPoints: PropTypes.array,
  svg: PropTypes.object,
};

Horizontal.propTypes = {
  y: PropTypes.func,
  ticks: PropTypes.array,
};

Both.propTypes = {
  ...Vertical.propTypes,
  ...Horizontal.propTypes,
};

const Direction = {
  VERTICAL: "VERTICAL",
  HORIZONTAL: "HORIZONTAL",
  BOTH: "BOTH",
};

const Grid = ({ direction, ...props }: any) => {
  if (direction === Direction.VERTICAL) {
    return <Vertical {...props} />;
  } else if (direction === Direction.HORIZONTAL) {
    return <Horizontal {...props} />;
  } else if (direction === Direction.BOTH) {
    return <Both {...props} />;
  }

  return null;
};

Grid.Direction = Direction;

Grid.propTypes = {
  direction: PropTypes.oneOf(Object.values(Direction)),
  belowChart: PropTypes.bool,
  svg: PropTypes.object,
};

Grid.defaultProps = {
  direction: Direction.HORIZONTAL,
  belowChart: true,
};

export default Grid;
